<template>
  <ModalComponent
    v-model="updateAvailable"
    modal-class="modal-version-watcher"
    :closable="false"
  >
    <template #header>Une mise à jour de MonEspace AKTO est disponible</template>
    <template #content>
      <div class="flex flex-column flex-gap-4 justify-content-center">
        <BasicText size="body-l">
          Une nouvelle version de MonEspace AKTO est disponible. Veuillez la mettre à jour pour profiter des dernières
          fonctionnalités et améliorations.
        </BasicText>
        <BasicAlert
          size="body-l"
          alertLabel="Vous pouvez continuer sans mettre à jour, mais des dysfonctionnements peuvent survenir. Pour appliquer la mise à jour ultérieurement, rechargez simplement la page (F5)."
        />
      </div>
    </template>
    <template #actions>
      <div class="flex justify-content-space-between">
        <BasicButton
          type="danger"
          label="Le faire plus tard"
          size="small"
          iconRight
          icon-name="close"
          @click="updateAvailable = false"
          weight="bold"
        />
        <BasicButton
          label="Mettre à jour"
          size="small"
          @click="reload"
          icon-name="validate"
          iconRight
          weight="bold"
        />
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
  import { useVersionWatcher } from './useVersionWatcher.ts'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'
  const { updateAvailable } = useVersionWatcher()
  const reload = () => window.location.reload()
</script>

<style lang="less">
  .modal-version-watcher {
    z-index: 1001 !important;
    div {
      max-width: 650px;
    }
  }
</style>
